export interface OcrRegion {x: number; y: number; width: number; height: number}
export interface ImageSize {width: number; height: number}
export type RegionHandle = 'n' | 'ne' | 'e' | 'se' | 's' | 'sw' | 'w' | 'nw'
export const regionEqual = (first: OcrRegion, second: OcrRegion) => ['x', 'y', 'width', 'height'].every(key => Math.abs(first[key as keyof OcrRegion] - second[key as keyof OcrRegion]) < .000001)
// The server expands requested bounds outwards to whole pixels before cropping.
export const regionMatchesCrop = (actual: OcrRegion, requested: OcrRegion, pixels?: ImageSize) => {
    if (!pixels?.width || !pixels.height) return regionEqual(actual, requested)
    const within = (difference: number, size: number) => difference > -.000001 && difference < 1 / size + .000001
    return within(requested.x - actual.x, pixels.width) && within(requested.y - actual.y, pixels.height)
        && within(actual.x + actual.width - requested.x - requested.width, pixels.width)
        && within(actual.y + actual.height - requested.y - requested.height, pixels.height)
}
const clamp = (value: number, minimum: number, maximum: number) => Math.min(maximum, Math.max(minimum, value))
export function resizeRegion(region: OcrRegion, handle: RegionHandle, dx: number, dy: number, minimumWidth = .002, minimumHeight = .002): OcrRegion {
    let left = region.x, right = region.x + region.width, top = region.y, bottom = region.y + region.height
    if (handle.includes('w')) left = clamp(left + dx, 0, right - minimumWidth)
    if (handle.includes('e')) right = clamp(right + dx, left + minimumWidth, 1)
    if (handle.includes('n')) top = clamp(top + dy, 0, bottom - minimumHeight)
    if (handle.includes('s')) bottom = clamp(bottom + dy, top + minimumHeight, 1)
    return {x: left, y: top, width: right - left, height: bottom - top}
}
